/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalServiceOptionDto } from '../models/AdditionalServiceOptionDto';
import type { AllowedDayDto } from '../models/AllowedDayDto';
import type { AvailableDaysDto } from '../models/AvailableDaysDto';
import type { BookingAppointmentRequest } from '../models/BookingAppointmentRequest';
import type { BookingAppointmentResponse } from '../models/BookingAppointmentResponse';
import type { BookingRequest } from '../models/BookingRequest';
import type { BookingSnap } from '../models/BookingSnap';
import type { BookResultDto } from '../models/BookResultDto';
import type { CarClass } from '../models/CarClass';
import type { FixedRepairPriceDto } from '../models/FixedRepairPriceDto';
import type { FuelType } from '../models/FuelType';
import type { GetNextAvailableDaysRequest } from '../models/GetNextAvailableDaysRequest';
import type { GetNotAvailableDaysRequest } from '../models/GetNotAvailableDaysRequest';
import type { HolidayResponse } from '../models/HolidayResponse';
import type { LookUpVehicleDto } from '../models/LookUpVehicleDto';
import type { LookUpVehicleRequest } from '../models/LookUpVehicleRequest';
import type { MotOptionDto } from '../models/MotOptionDto';
import type { QuoteRequestInputModel } from '../models/QuoteRequestInputModel';
import type { ServicePlanClassType } from '../models/ServicePlanClassType';
import type { ServicePlanPriceDto } from '../models/ServicePlanPriceDto';
import type { TimeSpan } from '../models/TimeSpan';
import type { TransportOptionDto } from '../models/TransportOptionDto';
import type { WlAppointType } from '../models/WlAppointType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingServiceService {

  /**
   * @param date 
   * @returns BookingSnap Success
   * @throws ApiError
   */
  public static getGetBookingSnap(
date?: string,
): CancelablePromise<BookingSnap> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetBookingSnap',
      query: {
        'date': date,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns LookUpVehicleDto Success
   * @throws ApiError
   */
  public static postLookupVehicle(
requestBody?: LookUpVehicleRequest,
): CancelablePromise<LookUpVehicleDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/LookupVehicle',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns string Success
   * @throws ApiError
   */
  public static postNotAvailableDays(
requestBody?: GetNotAvailableDaysRequest,
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/NotAvailableDays',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param month 
   * @param year 
   * @param additionalServiceOptionIds 
   * @param fixedRepairPriceIds 
   * @param servicePlanIds 
   * @param motIds 
   * @param selectedAdditionalWorks 
   * @param eventServiceIds 
   * @returns AvailableDaysDto Success
   * @throws ApiError
   */
  public static getGetNotAvailableDays(
branchId: number,
month: number,
year: number,
additionalServiceOptionIds?: Array<number>,
fixedRepairPriceIds?: Array<number>,
servicePlanIds?: Array<number>,
motIds?: Array<number>,
selectedAdditionalWorks?: Array<number>,
eventServiceIds?: Array<number>,
): CancelablePromise<Array<AvailableDaysDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetNotAvailableDays',
      query: {
        'branchId': branchId,
        'month': month,
        'year': year,
        'AdditionalServiceOptionIds': additionalServiceOptionIds,
        'FixedRepairPriceIds': fixedRepairPriceIds,
        'ServicePlanIds': servicePlanIds,
        'MotIds': motIds,
        'SelectedAdditionalWorks': selectedAdditionalWorks,
        'EventServiceIds': eventServiceIds,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param additionalServiceOptionIds 
   * @param fixedRepairPriceIds 
   * @param servicePlanIds 
   * @param motIds 
   * @param selectedAdditionalWorks 
   * @param eventServiceIds 
   * @returns AvailableDaysDto Success
   * @throws ApiError
   */
  public static getGetNextAvailableDay(
branchId: number,
additionalServiceOptionIds?: Array<number>,
fixedRepairPriceIds?: Array<number>,
servicePlanIds?: Array<number>,
motIds?: Array<number>,
selectedAdditionalWorks?: Array<number>,
eventServiceIds?: Array<number>,
): CancelablePromise<Array<AvailableDaysDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetNextAvailableDay',
      query: {
        'branchId': branchId,
        'AdditionalServiceOptionIds': additionalServiceOptionIds,
        'FixedRepairPriceIds': fixedRepairPriceIds,
        'ServicePlanIds': servicePlanIds,
        'MotIds': motIds,
        'SelectedAdditionalWorks': selectedAdditionalWorks,
        'EventServiceIds': eventServiceIds,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns AllowedDayDto Success
   * @throws ApiError
   */
  public static postNextAvailableDays(
requestBody?: GetNextAvailableDaysRequest,
): CancelablePromise<Array<AllowedDayDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/NextAvailableDays',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param transportOptionType
 *
 * 1 = MOTRAMP
 *
 * 2 = COLLECT
 *
 * 3 = RECALL
 *
 * 4 = WAITING
 *
 * 5 = StandartBooking
 *
 * 99 = Loan
 *
 * 100 = Diagnostic
 *
 * 101 = MOTRAMPHours
 *
 * 102 = TotalHours
   * @returns TimeSpan Success
   * @throws ApiError
   */
  public static getAvailableTimeSlots(
transportOptionType?: WlAppointType,
): CancelablePromise<Array<TimeSpan>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/AvailableTimeSlots',
      query: {
        'transportOptionType': transportOptionType,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns BookResultDto Success
   * @throws ApiError
   */
  public static postBook(
requestBody?: BookingRequest,
): CancelablePromise<BookResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Book',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns BookingAppointmentResponse Success
   * @throws ApiError
   */
  public static postBookAppointment(
requestBody?: BookingAppointmentRequest,
): CancelablePromise<BookingAppointmentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/BookAppointment',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postSaveQuotaRequest(
requestBody?: QuoteRequestInputModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveQuotaRequest',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns HolidayResponse Success
   * @throws ApiError
   */
  public static getGetHolidays(): CancelablePromise<Array<HolidayResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetHolidays',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param modelName 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param registrationDate 
   * @param carType
 *
 * 2 = Car (CAR)
 *
 * 5 = Van (VAN)
   * @param manufacturer 
   * @param branchId 
   * @param classType
 *
 * 1 = ManufacturerMenu
 *
 * 2 = EurorepairParts
 *
 * 3 = Flexible
 *
 * -1 = All
   * @param nextServiceDate 
   * @returns ServicePlanPriceDto Success
   * @throws ApiError
   */
  public static getGetServicePlanPrice(
modelName?: string,
fuelType?: FuelType,
registrationDate?: string,
carType?: CarClass,
manufacturer?: number,
branchId?: number,
classType?: ServicePlanClassType,
nextServiceDate?: string,
): CancelablePromise<ServicePlanPriceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetServicePlanPrice',
      query: {
        'modelName': modelName,
        'fuelType': fuelType,
        'registrationDate': registrationDate,
        'carType': carType,
        'manufacturer': manufacturer,
        'branchId': branchId,
        'classType': classType,
        'nextServiceDate': nextServiceDate,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns TransportOptionDto Success
   * @throws ApiError
   */
  public static getBookingServiceTransportOptions(): CancelablePromise<Array<TransportOptionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/BookingService/transport-options',
    });
  }

  /**
   * @param branchId 
   * @returns MotOptionDto Success
   * @throws ApiError
   */
  public static getBookingServiceMotOptions(
branchId?: number,
): CancelablePromise<Array<MotOptionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/BookingService/mot-options',
      query: {
        'branchId': branchId,
      },
    });
  }

  /**
   * @param branchId 
   * @returns AdditionalServiceOptionDto Success
   * @throws ApiError
   */
  public static getBookingServiceAdditionalServiceOptions(
branchId?: number,
): CancelablePromise<Array<AdditionalServiceOptionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/BookingService/additional-service-options',
      query: {
        'branchId': branchId,
      },
    });
  }

  /**
   * @param varclass 
   * @param regDate 
   * @returns FixedRepairPriceDto Success
   * @throws ApiError
   */
  public static getBookingServiceFixedPrices(
varclass?: string,
regDate?: string,
): CancelablePromise<Array<FixedRepairPriceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/BookingService/fixed-prices',
      query: {
        'varclass': varclass,
        'regDate': regDate,
      },
    });
  }

  /**
   * @param eventServiceType 
   * @returns MotOptionDto Success
   * @throws ApiError
   */
  public static getBookingServiceEventServices(
eventServiceType?: number,
): CancelablePromise<Array<MotOptionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/BookingService/event-services',
      query: {
        'eventServiceType': eventServiceType,
      },
    });
  }

}
